import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hb-login-container',
  templateUrl: './login-container.component.html',
})
export class LoginContainerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
